import { createCtx } from './contextFactory';

const [ctx, Provider] = createCtx({
    onlineUsers: []
});

export const PusherContext = ctx;

export const PusherProvider = Provider;
